import { SWRConfig } from "swr";
import type { PropsWithChildren } from "react";
import { apiClient } from "@/api/client";

interface FetchError extends Error {
  status?: number;
}

// Global fetcher that uses apiClient's auth
const fetcher = async (url: string) => {
  const response = await apiClient.authorizedFetch(url);
  if (!response.ok) {
    const error: FetchError = new Error("API error");
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export function SWRProvider({ children }: PropsWithChildren) {
  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        dedupingInterval: 2000,
        errorRetryCount: 2,
      }}
    >
      {children}
    </SWRConfig>
  );
}
